import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ActionState } from '@mkp/shared/models';
import { SnackbarConfig } from './snackbar.config';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  readonly snackbar = new Subject<SnackbarConfig>();
  readonly snackbar$: Observable<SnackbarConfig> = this.snackbar.asObservable();

  /**
   * Show a snackbar
   * @param title translation key of the message to show (or actual text)
   * @param snackbarConfig
   */
  show(title: string, snackbarConfig: Omit<SnackbarConfig, 'title'> = {}) {
    const config: SnackbarConfig = {
      state: ActionState.Success,
      title,
      ...snackbarConfig,
    };

    this.snackbar.next(config);
  }

  showError(title: string, config?: Omit<SnackbarConfig, 'state'>) {
    this.show(title, { state: ActionState.Error, ...config });
  }
}
